import { useParsed } from '@refinedev/core'
import { useTranslation } from 'react-i18next'
import { EditView, EditViewHeader } from '~/components/refineUi/views/editView'
import { TenantForm } from './form'

export function TenantEdit() {
  const { id } = useParsed()
  const { t } = useTranslation()
  return (
    <EditView>
      <EditViewHeader title={t('tenantsPage.edit.title')} />
      <TenantForm
        action="edit"
        id={String(id)}
      />
    </EditView>
  )
}
